(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["digital-marquee"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.digital-marquee');
    if (!section) return;

    const mask = section.querySelector('[data-marquee-mask]');
    const track = section.querySelector('[data-marquee-track]');
    const templateItem = section.querySelector('[data-marquee-item]');

    if (!mask || !track || !templateItem) return;

    const template = templateItem.cloneNode(true);

    const rebuild = () => {
      const maskWidth = mask.getBoundingClientRect().width;
      if (!maskWidth) return;

      track.innerHTML = '';

      track.appendChild(template.cloneNode(true));
      let sequenceWidth = track.getBoundingClientRect().width;

      while (sequenceWidth < maskWidth) {
        const clone = template.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
        sequenceWidth = track.getBoundingClientRect().width;
      }

      const sequenceHTML = track.innerHTML;
      track.insertAdjacentHTML('beforeend', sequenceHTML);

      track.querySelectorAll('[data-marquee-item]').forEach((node, index) => {
        if (index > 0) {
          node.setAttribute('aria-hidden', 'true');
        }
      });

      const totalWidth = track.scrollWidth;
      track.style.setProperty('--digital-marquee-distance', `${totalWidth / 2}px`);
    };

    rebuild();

    const resizeObserver = new ResizeObserver(() => rebuild());
    resizeObserver.observe(mask);
  })();

  } catch(e) { console.error(e); }
})();
})();
